import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { obtenerBancosAllAction } from "../../../ducks/bancoDuck"
import { Container, Grid } from "@material-ui/core"
import HomePage from "../../Home"
import FBanco from "../FBanco"
import TBanco from "../TBanco"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import BancoMain from "./../BancoMain"
import MMensualidad from "../MMensualidad"
export const VMetodoPago = () => {
    const { bancosMain, editar } = useSelector(store => store.bancoMain)

    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerBancosAllAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
    return (
        <HomePage>
            <Container maxWidth="xl">
                <Grid container>
                    <Grid item xs={12}>
                        <h3>Metodos de pago</h3>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: "1rem" }}>
                        <h4>Banco principal</h4>
                        <BancoMain />
                    </Grid>
                    {
                        (bancosMain.length !== 0 && !editar) &&
                        <Grid item xs={3}>
                            <FBanco />
                        </Grid>
                    }
                    {
                        (bancosMain.length !== 0 && !editar) &&
                        <Grid item xs={9}>
                            <TBanco />
                        </Grid>
                    }
                    <MMensualidad />
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VMetodoPago